import { REACT_APP__URL_SMP_API } from "@smp/utils";
import { apiRequest } from "../../..";
export const Progress = {
    chapter_pass: (req) => apiRequest({
        body: req.body,
        endpoint: `${REACT_APP__URL_SMP_API}/academy/v1/chapter_pass`,
        method: "POST",
    }),
    check_academy_passed: () => apiRequest({
        endpoint: `${REACT_APP__URL_SMP_API}/academy/v1/progress/check_academy_passed`,
        method: "POST",
    }),
    lesson_pass: (req) => apiRequest({
        body: req.body,
        endpoint: `${REACT_APP__URL_SMP_API}/academy/v1/lesson_pass`,
        method: "POST",
    }),
    retrieve: () => apiRequest({
        endpoint: `${REACT_APP__URL_SMP_API}/academy/v1/progress`,
        method: "GET",
    }),
};
//# sourceMappingURL=progress.js.map